import React from 'react';

export const CorrectSuccessIcon = ({
  width = '18',
  height = '18',
  color = '#027A48',
  'aria-hidden': ariaHidden = true,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    fill={color}
    viewBox="0 0 36 36"
    version="1.1"
    preserveAspectRatio="xMidYMid meet"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={ariaHidden}
    {...rest}
  >
    <path
      className="clr-i-outline clr-i-outline-path-1"
      d="M13.72,27.69,3.29,17.27a1,1,0,0,1,1.41-1.41l9,9L31.29,7.29a1,1,0,0,1,1.41,1.41Z"
    ></path>
    <rect x="0" y="0" width="36" height="36" fillOpacity="0"></rect>
  </svg>
);
